// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1CompanySchema } from './v1/companySchema';

export const get11AccountIdClientsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the clients you want to retrieve"),
});

export const get11AccountIdClientsQueryParamsSchema = z.object({
  limit: z.optional(z.number().int().describe("Retrieve number of clients")),
  order: z.optional(z.coerce.string().describe("\"asc (default)\" and \"desc\"")),
  offset: z.optional(z.number().int().describe("Retrieve clients from offset")),
  show: z.optional(z.enum(["all", "active", "archived"]).describe("Specifies which records to retrieve. Example: \"show=all\" or \"show=active\" or \"show=archived\"")),
}).optional();

export const get11AccountIdClientsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Client details
 */
export const get11AccountIdClients200Schema = z.array(z.lazy(() => v1CompanySchema));

export const get11AccountIdClientsQueryResponseSchema = z.lazy(() => get11AccountIdClients200Schema);
